import React from 'react';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';
import FormatTooling from '../../../tooling/formatTooling';

import GlassPopup from '../common/interface/glassPopup';

const RevisionActionsHistoryPopup = props => {
  const {
    handleShowPopup,
    revisionActionsHistoryInfo,
    revisionActionsHistoryData,
    popupState
  } = props;
  if (!revisionActionsHistoryInfo) {
    return null;
  }
  return (
    <GlassPopup
      className="form_popup revision_actions_history_popup"
      title={
        intl.formatMessage({ id:"supervisorsAdminRevisionPanel.revisionActionsHistoryPopupTitle"}) + ": " +
        revisionActionsHistoryInfo.supervisor_email + " - " +
        revisionActionsHistoryInfo.polynomial_name
      }
      {...props}
    >
      {revisionActionsHistoryData.action_history && (
        <ul>
          {revisionActionsHistoryData.action_history.map((revisionAction, index) => {
            return (
              <li key={index}>
                {
                  revisionAction.user_email + " " +
                  "(" + FormatTooling.defaultsTextFormatTypes(revisionAction.action_at, Constants.crudGenerator.dataTypes.DATETIME) + "): " +
                  intl.formatMessage({ id:"supervisorsAdminRevisionPanel.revisionHistoryActionTypes." + revisionAction.action}) +
                  (revisionAction.last_state ? " (" + 
                    intl.formatMessage({ id:"supervisorsAdminRevisionPanel.revision_states." + revisionAction.last_state}) + " -> " +
                    intl.formatMessage({ id:"supervisorsAdminRevisionPanel.revision_states." + revisionAction.new_state}) + ")"
                  : "") +
                  (revisionAction.message ? " - '" + revisionAction.message + "'" : "") 
                }
              </li>
            );
          })}
        </ul>
      )}
    </GlassPopup>
  );
};

export default RevisionActionsHistoryPopup;



// WEBPACK FOOTER //
// ./source/client/components/supervisorsAdminRevisionPanel/revisionActionsHistoryPopup.jsx